
import "@/assets/css/alfapay-btn.css"
import {defineComponent} from 'vue'


export default defineComponent({
  emits: ['btn:click']
})
